module.exports = __webpack_public_path__ + "img/idr_med.25946fdd.png";